import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NativeElementInjectorDirective } from './directives/native-element-injector.directive';
import { PhoneInputComponent } from './phone.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgxMaskModule } from 'ngx-mask';
import { PhoneE164InputComponent } from './phone164.component';

@NgModule({
  declarations: [
    PhoneInputComponent,
    PhoneE164InputComponent,
    NativeElementInjectorDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzSelectModule,
    NgxMaskModule.forRoot({})
  ],
  exports: [
    PhoneInputComponent,
    PhoneE164InputComponent,
    NativeElementInjectorDirective
  ]
})
export class PhoneInputModule {}
